import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () =>
  'create_record_' + (Math.floor(Math.random() * 90000000) + 10000).toString();

const initData = () => ({ outputKey: keyAuto(), columns: [] });

const onLoadData = (rawData) => {
  const data = { ...initData(), ...rawData };
  // v1 compat: key → outputKey
  if (rawData.key && !rawData.outputKey) {
    data.outputKey = rawData.key;
    delete data.key;
  }
  // v1 compat: columnValue → value within columns
  if (Array.isArray(data.columns)) {
    data.columns = data.columns.map((col) => {
      if (col.columnValue !== undefined && col.value === undefined) {
        const { columnValue, ...rest } = col;
        return { ...rest, value: columnValue };
      }
      return col;
    });
  }
  return data;
};

const { createStore, getStore, defaultStore } = createComponentStore({
  type: 'create_database_record',
  endpoint: 'create_database_record',
  registryKey: 'create_database_record',
  initData,
  onLoadData,

  extraState: () => ({
    placeholders: [],
    position: null,
    databaseList: [],
    targetDatabaseId: null,
  }),

  extraActions: (set, get) => ({
    // Backward-compat alias used by prefillComponentStores
    setCreateDatabaseRecordTemplate: (component) => {
      get().setComponentData(component);
      if (component.componentData?.targetDatabaseId) {
        set({ targetDatabaseId: component.componentData.targetDatabaseId });
      }
    },

    setKey: (value) =>
      set((s) => ({ data: { ...s.data, outputKey: value } })),

    setData: (columns) =>
      set((s) => ({ data: { ...s.data, columns } })),

    clearData: () =>
      set((s) => ({ data: { ...s.data, columns: [] } })),

    setDatabaseList: (databaseList) => set({ databaseList }),

    setTargetDatabaseId: (targetDatabaseId) => set({ targetDatabaseId }),

    setPlaceholders: (placeholders) => set({ placeholders: [...placeholders] }),

    setFocus: (index) => set({ position: index, placeholders: [] }),

    keyAuto,

    getTemplate: () => {
      const s = get();
      return {
        componentId: s.componentId,
        name: s.name,
        data: JSON.parse(JSON.stringify(s.data)),
        type: s.type,
        lastModified: s.lastModified,
        placeholders: [...s.placeholders],
        position: s.position,
        databaseList: s.databaseList,
        targetDatabaseId: s.targetDatabaseId,
      };
    },
  }),
});

export { createStore as createCreateDatabaseRecordStore };
export const getCreateDatabaseRecordStore = getStore;
export default defaultStore;
